import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import axiosInstance from "../services/axiosInstance";

// Component for the popup
const TextSubmitPopup = ({ showModal, closeModal }) => {
  const [text, setText] = useState("");
  const toast = useToast();

  const handleSubmit = async () => {
    try {
      await axiosInstance.post("/users/sendmail", { text });
      toast({
        title: "نجاح",
        description: "تم إرسال النص إلى المستخدمين بنجاح!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setText(""); // Clear the input field
      closeModal(); // Close the modal
    } catch (error) {
      toast({
        title: "خطأ",
        description: "فشل إرسال النص. حاول مرة أخرى لاحقًا.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={showModal} onClose={closeModal} isCentered>
      <ModalOverlay />
      <ModalContent dir="rtl">
        <ModalHeader textAlign="right">إرسال نص إلى المستخدمين</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="أدخل النص هنا"
            value={text}
            onChange={(e) => setText(e.target.value)}
            dir="rtl"
          />
        </ModalBody>
        <ModalFooter justifyContent="flex-start">
          <Button colorScheme="blue" ml={3} onClick={handleSubmit}>
            إرسال
          </Button>
          <Button variant="ghost" onClick={closeModal}>
            إلغاء
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default TextSubmitPopup;


